import React, { useEffect, useState, memo } from 'react'
import { connect } from 'react-redux'
import { Redirect, useHistory } from 'react-router-dom'
import watch from '../../assets/watch.svg'
import PopUpWrapper from '../../components/PopUpWrapper/PopUpWrapper'
import {
    UPDATE_ANTHE_DATA,
    UPDATE_HEADER_VISIBLE,
} from '../../constants/actionTypes'
import Api from '../../data'
import { useTranslation } from 'react-i18next'
import './Timer.css'
import { webengageTrackEvent } from 'utils/webengageService'
import { WEBENGAGE_EVENTS } from 'constants/webengageEvents'
import { ANTHE_EXAM_TYPES, ANTHE_TEST_TYPES } from 'constants/examTypeConstants'

const mapStateToProps = (state) => {
    return {
        testData: state.testpanel,
        testStatus: state.testStatus,
        timer: state.timer,
        queryparam: state.queryparam,
        instructions: state.instructions,
        calculated_time_left: state.calculated_time_left,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setAntheData: (payload) => dispatch({ type: UPDATE_ANTHE_DATA, payload }),
        setHeaderVisibility: (payload) =>
            dispatch({ type: UPDATE_HEADER_VISIBLE, payload }),
    }
}

const secondsToTime = (secs) => {
    let hours = Math.floor(secs / (60 * 60))
    let divisor_for_minutes = secs % (60 * 60)
    let minutes = Math.floor(divisor_for_minutes / 60)
    let divisor_for_seconds = divisor_for_minutes % 60
    let seconds = Math.floor(divisor_for_seconds)
    let obj = {
        hh: hours < 10 ? '0' + hours : hours,
        mm: minutes < 10 ? '0' + minutes : minutes,
        ss: seconds < 10 ? '0' + seconds : seconds,
    }
    return obj
}

const Timer = (props) => {
    const { i18n } = useTranslation()
    const [timeLeftPopUp, settimeLeftPopUp] = useState(false)
    const [time, setTime] = useState(secondsToTime(0))
    const [isRedirect, setisRedirect] = useState(false)
    const history = useHistory()
    const isMock = JSON.parse(sessionStorage.getItem('is_mock'))

    let timer
    let hindi = {
        minutes: 'मिनट',
        remaining_time: 'शेष बचे हैं',
    }
    let english = {
        minutes: 'Minutes',
        remaining_time: 'remaining in the test',
    }
    let t = 0

    if (props.timer.hasOwnProperty('t')) {
        t = parseInt(sessionStorage.getItem('timer') || props.timer.t)
    }

    const handleRedirect = () => {
        localStorage.setItem(
            'examName',
            JSON.stringify(props.instructions.testData?.title),
        )
        setisRedirect(false)

        Api.submitTest(props, true)
            .then((res) => res.data)
            .then((res) => {
                if (res.finalSubmit === true) {
                    setTime(secondsToTime(0))
                    history.push({ pathname: '/success' })
                }
            })
            .catch((error) => {})
    }

    const countDown = () => {
        t -= 1

        if (t < 1) {
            clearInterval(timer)
            if (
                (!isMock &&
                    ANTHE_EXAM_TYPES.includes(
                        props.queryparam.exam_type.toLowerCase(),
                    )) ||
                ANTHE_TEST_TYPES.includes(props.queryparam.exam_type.toLowerCase())
            ) {
                clearInterval(timer)
                handleRedirect()
            } else if (!t) {
                sessionStorage.setItem('timer', t)
                Api.submitTest(props, true)
                    .then((res) => res.data)
                    .then((res) => {
                        if (
                            res.finalSubmit === true ||
                            (isMock && res === 'Success')
                        ) {
                            setTime(secondsToTime(0))
                            setisRedirect(true)
                        }
                    })
                    .catch((error) => {})
            }
            webengageTrackEvent(WEBENGAGE_EVENTS.TP_AUTO_SUBMIT_TEST)
        } else {
            sessionStorage.setItem('timer', t)
            setTime(secondsToTime(t))

            if (t == props.instructions.testData.reminderTimeForTestEnding * 60) {
                settimeLeftPopUp(true)
            }
        }
    }

    useEffect(() => {
        if (props.calculated_time_left > 0) {
            clearInterval(props.timerAddress)
            clearInterval(timer)
            timer = setInterval(countDown, 1000)
            props.setTimer(timer)
        }

        return () => {
            clearInterval(props.timerAddress)
            clearInterval(timer)
        }
    }, [props.calculated_time_left, props.testStatus])

    if (isRedirect === true) {
        return <Redirect to="/results" />
    }
    return props.timer && props.timer.hideTimer === false ? (
        <div role="timer" className={props.class} id={props.id}>
            {time.hh + ' : ' + time.mm + ' : ' + time.ss}
            {timeLeftPopUp ? (
                <PopUpWrapper callback={settimeLeftPopUp}>
                    <div className="timeleft">
                        <div className="image-div">
                            <img className="popup-image" src={watch} alt="popup" />
                        </div>
                        <div className="popup-text">
                            <span className="popup-main-text">
                                <h2 className="h2_class">
                                    {i18n.language == 'hi' ? (
                                        <span>टेस्ट में</span>
                                    ) : null}
                                    <div className="remaining-time">
                                        {
                                            props.instructions.testData
                                                .reminderTimeForTestEnding
                                        }
                                        <span className="minutes-span">
                                            {
                                                (i18n.language == 'en'
                                                    ? english
                                                    : hindi
                                                ).minutes
                                            }
                                        </span>
                                    </div>
                                </h2>
                            </span>
                            <p style={{ margin: '0px' }}>
                                {
                                    (i18n.language == 'en' ? english : hindi)
                                        .remaining_time
                                }
                            </p>
                        </div>
                    </div>
                </PopUpWrapper>
            ) : null}
        </div>
    ) : (
        ''
    )
}

export default memo(connect(mapStateToProps, mapDispatchToProps)(Timer))
